var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 78,
    viewBox: "0 0 74 78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #d6d8e1;\n        fill-rule: evenodd;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Arrow_40_-_www.Shapes4FREE.com1",
    "data-name": "Arrow 40 - www.Shapes4FREE.com1",
    className: "cls-1",
    d: "M31.139,2.619L3.58,30.21A8.936,8.936,0,0,0,16.211,42.856L28.523,30.529V68.6a8.931,8.931,0,1,0,17.862,0V30.529L58.7,42.856A8.936,8.936,0,0,0,71.329,30.21L43.77,2.619A8.924,8.924,0,0,0,31.139,2.619Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow_up.fc9b2cd68ec5e05ad718ea4c54588c3d.svg";
export { ForwardRef as ReactComponent };